import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, RoundDoneIcon, Text } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface ResetPasswordSuccessProps {
  onGoToLogin: () => void;
}

const ResetPasswordSuccess: React.FC<ResetPasswordSuccessProps> = ({ onGoToLogin }) => {
  const { t } = useTranslation();

  return (
    <Box
      dir="column"
      align="center"
      data-testid="reset-password_success-screen"
    >
      <RoundDoneIcon size="48px" data-testid="reset-password_success-icon" />

      <Text
        size="2xl"
        weight={700}
        textAlign="center"
        margin={{ top: 'spacing8' }}
        data-testid="reset-password_success-title"
      >
        {t('Password Updated')}
      </Text>

      <Text
        textAlign="center"
        size="large"
        margin={{ top: 'spacing8' }}
        data-testid="reset-password_success-subtitle"
      >
        {t('You can now sign in with your new password.')}
      </Text>

      <Box margin={{ top: 'spacing16' }} width="100%">
        <AppButton
          testId="reset-password_go-to-login-btn"
          onClick={onGoToLogin}
          width="100%"
          size="L"
        >
          {t('Sign In')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default ResetPasswordSuccess;
